import { useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Divider from "@mui/material/Divider";
import MDBox from "components/MDBox";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";

// Compose + send an ad-hoc message to a chat profile (fire-and-forget via OpenClaw).
interface Props {
  profile: { id: string; channel: string; channelUserId: string; displayName?: string };
  busy?: boolean;
  onClose: () => void;
  onSend: (message: string) => void;
}

function SendMessageModal({ profile, busy, onClose, onSend }: Props): JSX.Element {
  const [message, setMessage] = useState("");
  const to = profile.displayName
    ? `${profile.displayName} (${profile.channelUserId})`
    : profile.channelUserId;

  return (
    <Dialog maxWidth="sm" fullWidth open onClose={onClose}>
      <MDBox display="flex" alignItems="center" justifyContent="space-between">
        <DialogTitle>
          <MDTypography fontSize="16px" fontWeight="medium">
            Send message
          </MDTypography>
        </DialogTitle>
        <IconButton onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </MDBox>
      <DialogContent>
        <MDTypography variant="button" color="text" fontWeight="regular">
          To {profile.channel} · {to}
        </MDTypography>
        <MDBox mt={2}>
          <MDInput
            label="Message"
            multiline
            rows={4}
            fullWidth
            value={message}
            onChange={(e: any) => setMessage(e.target.value)}
          />
        </MDBox>
      </DialogContent>
      <Divider />
      <DialogActions sx={{ display: "flex", justifyContent: "space-between" }}>
        <MDButton variant="outlined" color="primary" onClick={onClose}>
          Cancel
        </MDButton>
        <MDButton
          variant="contained"
          color="primary"
          disabled={busy || !message.trim()}
          onClick={() => onSend(message.trim())}
        >
          Send
        </MDButton>
      </DialogActions>
    </Dialog>
  );
}

export default SendMessageModal;
